/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */
import { User } from "../models/User.model";
import { ApiService } from "../services/Api.service";
import { Resource, SingleDocument } from "../utils/json-api";
import { getErrorFromCode } from "src/utils/errorHelper";

/**
 *
 */
export class UserApi {
    /**
     *
     */
    constructor(private api: ApiService) {}

    async getMe(): Promise<User> {
        const response = await this.api.get<User>(`/users/me`);
        const resDoc = response.asSingleDocument();
        if (resDoc.hasError()) {
            throw getErrorFromCode(resDoc.getErrors()[0].code);
        }
        return resDoc.getModel();
    }

    async getUserById(id: string): Promise<User> {
        const response = await this.api.get<User>(`/users/one/${id}`);
        const resDoc = response.asSingleDocument();
        return resDoc.getModel();
    }

    async updateUser(user: User): Promise<User> {
        const reqDoc = new SingleDocument<User>().setResource(new Resource<User>(User.TYPE, user));
        const response = await this.api.patch<User>(`/users/${user.id}/`, reqDoc);
        const resDoc = response.asSingleDocument();
        return resDoc.getModel();
    }

    async testStressCustomers(): Promise<User> {
        const response = await this.api.get<User>(`/test/stress-customers`);
        const resDoc = response.asSingleDocument();
        return resDoc.getModel();
    }
}



// WEBPACK FOOTER //
// ./src/api/User.api.ts